import { Dictionary } from './types';

export function entries<Value = any>(target: Array<Value>): Generator<[number, Value]>;
export function entries<Value = any>(target: Dictionary<Value>): Generator<[string, Value]>;
export function entries<Key extends string | number | symbol, Value = any>(target: Record<Key, Value>): Generator<[Key, Value]>;

/**
 * Creates an iterator that iterates through the keys/values of objects and indexes/values of arrays
 */
export function* entries(target: any) {
	if (typeof target !== 'object') return;

	if (Array.isArray(target)) {
		for (let i = 0; i < target.length; ++i) yield [i, target[i]];

		return;
	}

	for (const key in target) {
		if (!Object.prototype.hasOwnProperty.call(target, key)) continue;

		yield [key, target[key]];
	}
}